import styled from 'styled-components'

import { H5 } from 'components/Typography'
import theme from 'theme_'
import { WhiteBlock } from 'components/Layout'

export const StyledJobHeader = styled(H5)`
  padding-top: 32px;
  text-align: center;
  color: ${theme.colors.disabledGrey};
`

export const StyledJobsPage = styled.div``

export const JobsPageInner = styled.div`
  margin: 20px 0 0 0;
  padding: 0 10px;

  @media ${theme.devices.desktop} {
    padding: 0 40px;
  }
`

export const JobBlockContainer = styled(WhiteBlock)`
  justify-content: center;
  align-items: center;
  padding: 24px;
  color: ${theme.colors.menuDark};
`
